/**
 * A seller is "paying" only when actively on a paid subscription.
 *
 * Trial sellers sit on a paid plan handle (`scale`) but have NOT paid a cent, so we
 * key off `subscriptionStatus`, never `plan.handle` / `canUseFeature`. This is the
 * gate for "may this seller turn our branding off / enable the Stripe badge".
 *
 * `comped` is an admin-granted paid plan with no Stripe subscription (design
 * partners, sponsorships). They get the full paid experience.
 */
export default function isPayingSeller(seller) {
  const status = seller?.subscriptionStatus;
  return status === 'active' || status === 'legacy' || status === 'comped';
}
